
const routes = [
  {
    path: '/lect',
    redirect: { name: 'LectList' },
    meta: { layout: 'default' },
    children: [
      // 교육·강좌 목록
      {
        path: 'list/:instId?',
        name: 'LectList',
        meta: { layout: 'default', menu: 'lect' },
        component: () => import('@/pages/lect/LectListView.vue')
      },
      // 교육·강좌 상세
      {
        path: 'detail/:instId/:gdsId/:lsnId',
        name: 'LectDetail',
        meta: { layout: 'default', menu: 'lect' },
        component: () => import('@/pages/lect/LectDetailView.vue'),
        props: true
      },
      // 교육·강좌 예약
      {
        path: 'rsvt/:instId/:gdsId/:lsnId',
        name: 'LectRsvt',
        meta: { layout: 'default', menu: 'lect' },
        component: () => import('@/pages/lect/LectRsvtView.vue'),
        props: true
      },
      // 교육·강좌 완료
      {
        path: 'done',
        name: 'LectDone',
        meta: { layout: 'default', menu: 'lect' },
        component: () => import('@/pages/lect/LectDoneView.vue')
      },
    ]
  }
]

export default routes


